export default function clearQueue(q) {
  var p = Promise.resolve();

  return q.reduce(function(prev, cur) {
    return prev.then(cur);
  }, p);
}
